import GeoJSON from 'ol/format/GeoJSON';
import type { SimpleGeometry } from 'ol/geom';
import type { ReadOptions, WriteOptions } from 'ol/format/Feature';
import type { Geometry as GeoJSONGeometry } from 'geojson';

const geoJSON = new GeoJSON();

export function serialize (simpleGeometry: SimpleGeometry | null, options?: WriteOptions): GeoJSONGeometry | null {
  return simpleGeometry ? geoJSON.writeGeometryObject(simpleGeometry, options) : null;
}

export function deserialize (geometry: GeoJSONGeometry | null, options?: ReadOptions): SimpleGeometry | null {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore it's protected, but we can use it
  return geometry ? geoJSON.readGeometryFromObject(geometry, options) : null;
}
